import { render, staticRenderFns } from "./CmsIndex.vue?vue&type=template&id=18c059b2&scoped=true"
import script from "./CmsIndex.vue?vue&type=script&lang=js"
export * from "./CmsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c059b2",
  null
  
)

export default component.exports